"use client";

import { c as _c } from "react/compiler-runtime";
import { IconChevronDown } from "@tabler/icons-react";
import { useId, useState } from "react";
import { trackAdvancedOptionsToggled } from "@/lib/analytics/segment";
import { cn } from "@/lib/utils";
interface Props {
  children: React.ReactNode;
}
export default function AdvancedOptions(t0) {
  const $ = _c(20);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const contentId = useId();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setIsOpen(_temp);
      trackAdvancedOptionsToggled();
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Advanced Options</span>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isOpen && "rotate-180";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("transition-transform", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t4) {
    t5 = <IconChevronDown size={16} className={t4} />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== contentId || $[7] !== isOpen || $[8] !== t5) {
    t6 = <button type="button" aria-expanded={isOpen} aria-controls={contentId} onClick={t1} className="flex w-full justify-between items-center gap-2 text-sm font-medium">{t2}{t5}</button>;
    $[6] = contentId;
    $[7] = isOpen;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const t7 = !isOpen;
  const t8 = !isOpen && "hidden";
  let t9;
  if ($[10] !== t8) {
    t9 = cn("flex flex-col gap-8", t8);
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== children || $[13] !== contentId || $[14] !== t7 || $[15] !== t9) {
    t10 = <div id={contentId} aria-hidden={t7} className={t9} data-slot="advanced-options-content">{children}</div>;
    $[12] = children;
    $[13] = contentId;
    $[14] = t7;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t6) {
    t11 = <div className="flex flex-col gap-3 has-[[data-slot=advanced-options-content]:empty]:hidden" data-testid="advanced-options">{t6}{t10}</div>;
    $[17] = t10;
    $[18] = t6;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  return t11;
}
function _temp(open) {
  return !open;
}